import React from 'react';
import cbcLogo from "../assets/images/home/brand-profile/cbc-logo.png";
import facebookLogo from "../assets/images/home/brand-profile/facebook.png";
import instagramLogo from "../assets/images/home/brand-profile/instagram.png";
import linkedinLogo from "../assets/images/home/brand-profile/linkedin.png";
import twitterLogo from "../assets/images/home/brand-profile/twitter.png";
import {NavLink} from "react-router-dom";

const BrandProfile = () => {
  return (
      <section className="brand-profile">
        <div className="custom-container">
          <div className="row mx-1 mx-lg-0">
            <div className="col-xl-2">
              <img width="110" src={cbcLogo} alt=""/>
            </div>
            <div className="col-xl-10 mt-4 mt-xl-0">
              <div className="row">
                <div className="col-lg-3">
                  <p className="about-us-text mb-4">About us</p>
                  <ul className="list-unstyled">
                    <li>
                      <NavLink target='_blank' to="/about" className="footer-link-text">About CBC</NavLink>
                    </li>
                    <li>
                      <a target='_blank' href="https://nbr.gov.bd/about-us/finance-minister-profile/eng"
                         className="footer-link-text">Finance Minister's Profile</a>
                    </li>
                    <li>
                      <a target='_blank' href="https://cbc.gov.bd/website/chairman_profile" className="footer-link-text">Chairman's Profile</a>
                    </li>
                    <li>
                      <a target='_blank' href="https://cbc.gov.bd/website/chairman_message" className="footer-link-text">Chairman's Message</a>
                    </li>
                  </ul>
                </div>
                <div className="col-lg-5 mt-4 mt-lg-0">
                  <p className="about-us-text">Contact us</p>
                  <p className="mb-1 mt-4">
                    National Board of Revenue,
                  </p>
                  <p className="mb-1">
                    Rajashwa Bhaban,
                  </p>
                  <p className="mb-1">
                    Plot# F 1/A Agargaon, Sher-E-Bangla Nagar, Dhaka-1207.
                  </p>
                  <p className="mb-1">
                    Tel: <a href="tel:0222221770009">02222217700-09</a>
                  </p>
                  <p>
                    Email: &nbsp;
                    <a className="mb-0" href='mailto:feedbackcustoms@nbr.gov.bd'>
                      feedbackcustoms@nbr.gov.bd
                    </a>
                  </p>
                </div>
                <div className="col-lg-4">
                  <div
                      className="d-flex justify-content-md-end social-media-logo-section"
                  >
                    <div className="white-circle">
                      <a href="#" target="_blank">
                        <img
                            className="facebook-logo"
                            src={facebookLogo}
                            alt=""
                        />
                      </a>
                    </div>
                    <div className="white-circle">
                      <a href="#" target="_blank">
                        <img
                            className="instagram-logo"
                            src={instagramLogo}
                            alt=""
                        />
                      </a>
                    </div>
                    <div className="white-circle">
                      <a href="#" target="_blank">
                        <img
                            className="twitter-logo"
                            src={twitterLogo}
                            alt=""
                        />
                      </a>
                    </div>
                    <div className="white-circle">
                      <a href="#" target="_blank">
                        <img
                            className="linkedin-logo"
                            src={linkedinLogo}
                            alt=""
                        />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
  );
};

export default BrandProfile;
